import React from "react";
import { Player, Controls } from "@lottiefiles/react-lottie-player";

const AnimationPlayer = ({
  animationSrc,
  playerHeight = "100vh",
  playerWidth = "500px",
  playerMarginTop = "0",
}) => {
  return (
    <Player
      autoplay
      loop
      src={animationSrc}
      style={{ height: playerHeight, width: playerWidth, marginTop: playerMarginTop }}
    >
      <Controls
        visible={false}
        buttons={["play", "repeat", "frame", "debug"]}
      />
    </Player>
  );
};

export default AnimationPlayer;
